import { Controller } from '@hotwired/stimulus';

// 行は data-nested-fields-item と data-new-record を持ち、_destroy の hidden を行の直下に置く
// 2 段の入れ子では行の要素にもこのコントローラを付け、targets と actions は一番近いコントローラにだけ効かせる
export default class extends Controller {
  static targets = ['template', 'container'];

  static values = {
    // 関連ごとに変えないと、外側の雛形を置き換えたときに中にある内側の雛形まで置き換わる
    placeholder: String,
  };

  #lastIndex = 0;

  // action="nested-fields#add"
  // 雛形はサーバが新規オブジェクトで描画したもので、ユーザーの入力を含まない
  add() {
    if (!this.hasTemplateTarget || !this.hasContainerTarget) return;

    // 同じミリ秒に押しても index が重ならないようにする
    this.#lastIndex = Math.max(Date.now(), this.#lastIndex + 1);
    const html = this.#templateHTML.replaceAll(
      this.placeholderValue,
      this.#lastIndex,
    );
    this.containerTarget.insertAdjacentHTML('beforeend', html);
  }

  // action="nested-fields#remove"
  // data-confirm にすると、document で受ける UJS より先にこのアクションが走って確認を素通りする
  remove({ currentTarget, params: { confirm } }) {
    if (confirm && !window.confirm(confirm)) return;

    const item = currentTarget.closest('[data-nested-fields-item]');
    if (!item) return;

    if (item.dataset.newRecord === 'true') {
      item.remove();
      return;
    }

    // _destroy が無い行を隠すと、消えたように見えて保存では残る
    const destroy = item.querySelector(':scope > input[name$="[_destroy]"]');
    if (!destroy) return;

    destroy.value = '1';
    item.hidden = true;
  }

  // Vue がコンパイルする範囲では <template> が展開されて消えるので、<script type="text/html"> も受ける
  get #templateHTML() {
    const template = this.templateTarget;
    return template instanceof HTMLTemplateElement
      ? template.innerHTML
      : template.textContent;
  }
}
